/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_LowInputs */

const cs_enum_low = /** @type {(inputs: Enum_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nízká`)
};

const en_enum_low = /** @type {(inputs: Enum_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Low`)
};

/**
* | output |
* | --- |
* | "Low" |
*
* @param {Enum_LowInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_low = /** @type {((inputs?: Enum_LowInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_LowInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_low(inputs)
	return cs_enum_low(inputs)
});